import { DriveStep } from 'driver.js'
import i18n from 'i18next'

const TITLE_DRIVER = i18n.t('New training')

const getClassificationCustomDriverSteps = (): DriveStep[] => [
  {
    element: '#divBackboneId',
    popover: {
      title: TITLE_DRIVER,
      description: i18n.t('Select one or more backbones.'),
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '#fp16SwitchId',
    popover: {
      title: TITLE_DRIVER,
      description: i18n.t(
        'Enable the FP16 model precision for faster training and inference. The performance might be slightly lower.'
      ),
      side: 'bottom',
      align: 'start',
    },
  },
]

export default getClassificationCustomDriverSteps
